import type { ActivityType } from '../../../typings'
import type { State } from '../../typings'

export const fetchActivityByIdProducer = (
  state: State,
  payload?: ActivityType,
) => ({
  ...state,
  current: payload,
})
